import Phrase from 'libs/translationsUtils/phrase'
import SearchResultsSection from './SearchResultsSection'
import HitContainerHeader from './HitContainerHeader'

const COMMUNITY_RESULTS = 0
const ZENDESK_RESULTS = 1

const HitContainerFederated = ({ indexName, allSearchResults, inputValue, hits, doSearch, highlightedIndex, getItemProps, style }) =>
  <div key='results' className='algolia-hit-container' style={style}>
    <HitContainerHeader
      inputValue={inputValue}
      hasResults={((hits[COMMUNITY_RESULTS].hits.length + hits[ZENDESK_RESULTS].hits.length) > 0)}
      doSearch={doSearch}
    />

    <SearchResultsSection
      title={<Phrase p='nav.title.community' />}
      type='community'
      searchResults={allSearchResults[indexName]}
      hits={hits[COMMUNITY_RESULTS].hits}
      highlightedIndex={highlightedIndex}
      getItemProps={getItemProps}
      previousResultsCount={0}
    />

    <SearchResultsSection
      title={<Phrase p='federated.search.zendesk' />}
      type='zendesk'
      searchResults={allSearchResults[`${indexName}-zendesk`]}
      hits={hits[ZENDESK_RESULTS].hits}
      highlightedIndex={highlightedIndex}
      getItemProps={getItemProps}
      previousResultsCount={hits[COMMUNITY_RESULTS].hits.length}
    />

    <a className='link algolia-search__createTopic' href='/topic/new'>
      <Phrase p='live.search.ask.question' />
    </a>
  </div>

export default HitContainerFederated
